import customerSupportService from './customerSupportService.js';
angular
    .module('support.supportService', ['signalview.orgSubscription'])
    .service('customerSupportService', customerSupportService);
